import jwtEncode from "jwt-encode";
import { jwtDecode } from "jwt-decode";

export const isMobile = (width, height) => {
  return width < 1000 && height > width ? true : false;
};

export const validateAvatar = (url, name = "") => {
  return url ? (
    <img src={url} referrerPolicy="no-referrer" alt="userIcon" />
  ) : (
    <span className="initials">
      {name
        ?.split(" ")
        ?.slice(0, 2)
        ?.map((word) => word[0])
        ?.join("")
        ?.toUpperCase()}
    </span>
  );
};

export const generateThumbnailFromFile = (file, width = 100, height = 100, quality = 0.7) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        const thumbnail = canvas.toDataURL("image/jpeg", quality);
        resolve(thumbnail);
      };
      img.onerror = () => reject(new Error("Image load error"));
      img.src = event.target.result;
    };

    reader.onerror = () => reject(new Error("File read error"));
    reader.readAsDataURL(file);
  });
};

export const redirectToUno = ({ configData }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const _tokenParam = urlParams.get("referrer");
  let token = "";
  let initialPath = null;
  if (_tokenParam) {
    const decoded = jwtDecode(_tokenParam);
    localStorage.setItem("token", decoded?.token);
    token = decoded?.token;
    initialPath = decoded?.redirectUri;
  } else if (localStorage.getItem("token")) {
    token = localStorage.getItem("token");
  }
  localStorage.clear();
  sessionStorage.clear();
  const payload = {
    origin: window.location.origin,
    redirectUri: window.location.pathname,
  };
  token = jwtEncode(payload, "");
  window.location.href = `${configData?.config?.redirectUri}?referrer=${token}`;
};
